import debounce from "lodash/debounce";
import $ from 'jquery';

import {getMetadataByDimensions, scrollToDivInArea} from "../../../misc/utils";
import {getEventPosition, getFeatureIsLocked, isIframe} from "../../../misc/helpers";
import {vanityWizardFilters, showerWizardFilters, NotQCVanityDoorStylesFilters} from '../../bvComponent/core/constants';
import {
  CABINET_GROUP,
  CABINET_WIZARD_BUTTONS, COUNTERTOP_GROUP,
  COUNTERTOP_WIZARD_BUTTONS, LayoutAbbreviations,
  MODULE_CONTEXT_MENU_TYPES
} from '../../kvComponent/core/constants';
import {ContentType, PartMenuType, UserPopupTypes} from "../constants";
import ActionTypes from "../../../misc/actionTypes";
import Analytics from './../../../analytics';
import {getBvGroupFeatures} from "../../../api/server-api";
import {loaderDisable, loaderEnable} from "../../ui/loaderView";

import {getCurrentLayout} from "../../appLayout";
import CountertopSwitchers from "../../kvComponent/navigation/countertopSwitchers";
import CabinetSwitchers from "../../kvComponent/navigation/cabinetSwitchers";
import NavigationRequests from "./navigationRequests";
import {toggleUpdateDisableFeatureGroupRadio} from "../../../actions/navigationFunctions";
import store from "../../../store";
import {CABINET_GROUP_BATHROOM, COUNTERTOP_GROUP_BATHROOM} from "../../bvSceneComponent/core/constants";
import Config from "../../../config";
import {
  // checkForCompatabilityAlert,
  clickOnSimilarFeatures,
  getApplyToLogic,
} from "../../look/lookNavigation/lookNavigationFunctions";
import {navFeatureCLick} from "../../look/lookNavigation/lookFunctions";
import {updateCanvasCount} from "../../../actions/actionFunctions";
import {VISUALIZER_MANAGEMENT_ACTIONS} from "../../../misc/constants";
import {searchProductRequest} from "../../../api/search-api";
import {featureCanChangeShowerSize, searchForSameNameWallsBeforeFeatureApply} from "../../look/bathroomFunctions";
import {getSideBarSubParts} from "./navUtils";
import {isFeatureNotInVisualizerNow, isNavItemNotInVisualizer} from "../featuresFunctions";
// import {setLookCompatabilityAlert} from "../../../actions/lookFunctions";

export default class Navigation extends NavigationRequests {  // this class is used for both Desktop & Mobile navigations to avoid method's duplicating

  constructor(props) {
    super(props);
    this.state = {
      showNavigation: false,
      contentType: ContentType.None,
      parentNavigationItem: null, // coming from main menu, Vanity, Floor, ...
      childNavigationItem: null, // coming from a complex part's sub part, such as Vanity/Toilet
      searchText: "",
      designNavigationItems: [],
      contextMenuOpen: false,
      hoveredLayer: {},
      navWidth: 0,
      contextMenuPosition: {
        top: 0,
        left: 0
      },
      contextMenuPonyWall: false,
      filters: {},
      activeDefaultPreset: null,
      updateSidebarItems: false,
      vanityWizardGroups: vanityWizardFilters.map((filterName) => { // filterGroupsId's & their selected values
        return {
          filterName,
          selectedValueId: null,
          selectedValueName: "",
          hidden: filterName === "Material"
        }
      }),
      showerWallWizardGroups: showerWizardFilters.map((filterName) => { // filterGroupsId's & their selected values
        const wizardFilters = ["SlabColor", "TileColor", "TilePattern", "AcrylicPattern", "AcrylicColor"];
        return {
          filterName,
          selectedValueId: null,
          selectedValueName: "",
          hidden: wizardFilters.includes(filterName)
        }
      }),
      showerWallWizardGroupsSelected: false,
      showFeatureWizard: true,
      wizardStepIndex: 0,
      wizardActiveItemIsLocked: false,
      showFilterSelection: false
    };

    this.shouldRecoverWalls = false;
    this.navigationIsClosing = false;
    this.defaultPresetIndexToClick = null;
  }

  _componentDidMount() {
    const layout = getCurrentLayout();
    this.setState({
      designNavigationItems: layout.designNavigationItems(),
    });
    this.setIframeMessaging();
    this.attachCanvasClick();
    $(document).on(ActionTypes.USER_IS_LOGGED_IN, this.userHasLoggedIn);
    if (window.innerWidth < 480) { // workarounds for screens without the rotate icon
      // if (!window.rotatedCanvasTranslateIsSet) { // making canvas scroll to center
      //   setTimeout(() => {
      //     const $canvas = $('.canvas');
      //     $canvas.css("transform", `translateY(${window.innerWidth - $canvas.height()}px`);
      //     window.rotatedCanvasTranslateIsSet = true;
      //   }, 500);
      // }
      $(".room .menu").hide();
      setTimeout(() => {
        $(".room .menu").show(); // fix for menu blocking the main canvas
      }, 0)
    }

  }

  // The <canvas> element the click listener is currently attached to.
  //
  // This used to be a boolean (_canvasClickBound) plus a one-shot "dockCanvasReady"
  // listener that was removed after the first successful attach. That breaks as soon
  // as the canvas element is REPLACED while this navigation stays mounted, which
  // happens on an orientation change: the canvas component remounts (the docked
  // shell can unmount/remount its wrapper, and on the non-docked path the canvas
  // subtree is re-created), so our listener goes away with the old DOM node while
  // the boolean stayed true and the ready-listener was already unsubscribed --
  // nothing ever re-bound and taps/clicks on the canvas silently stopped working
  // (reproduced on mobile with landscape -> portrait -> landscape).
  //
  // Keeping the element itself lets us re-bind whenever the live element for our
  // canvasId is a different node than the one we're attached to.
  _boundCanvasEl = null;

  // Attach the canvas click. The canvas may live in the docked visualizer shell,
  // which mounts a frame after navigation; if it isn't in the DOM yet, the
  // "dockCanvasReady" event (dispatched by the canvas on mount) brings us back.
  attachCanvasClick = () => {
    // Stay subscribed for this component's whole life -- the canvas can be created
    // more than once, and every re-creation announces itself with this event.
    window.addEventListener('dockCanvasReady', this._onDockCanvasReady);
    // Orientation / resize belt-and-braces for any canvas remount that happens
    // without the event above (older canvas paths, pinch-zoom re-parenting, ...).
    window.addEventListener('resize', this._recheckCanvasClick);
    window.addEventListener('orientationchange', this._recheckCanvasClick);
    this._bindCanvasClickToLiveEl();
  };

  // Idempotent: binds to whatever element currently owns our canvasId, and does
  // nothing when we're already attached to it.
  _bindCanvasClickToLiveEl = () => {
    const canvasEl = document.getElementById(this.props.canvasId);
    if (!canvasEl || canvasEl === this._boundCanvasEl) {
      return;
    }
    if (this._boundCanvasEl) { // stale node from a previous mount
      this._boundCanvasEl.removeEventListener('click', this._handleCanvasClick);
    }
    canvasEl.addEventListener('click', this._handleCanvasClick);
    this._boundCanvasEl = canvasEl;
    this._canvasClickBound = true;
  };

  _recheckCanvasClick = debounce(() => {
    this._bindCanvasClickToLiveEl();
  }, 150);

  // Swallow the synthetic "click" the browser fires at the end of a canvas
  // pan/drag. Without this, finishing a drag re-runs the hover hit-test at the
  // drop point and opens the navigation menu, which looks wrong. The pan gesture
  // sets window.canvasWasDragged (see VisualizerAdapter); we consume it here so
  // only genuine clicks reach bindCanvasClick.
  _handleCanvasClick = (event) => {
    if (!window.location.hash.includes("visualizer")) {
      return
    }
    if (window.canvasWasDragged) {
      window.canvasWasDragged = false;
      return;
    }
    this.bindCanvasClick(event);
  };

  _onDockCanvasReady = (event) => {
    if (event && event.detail && event.detail.canvasId && event.detail.canvasId !== this.props.canvasId) {
      return;
    }
    this._bindCanvasClickToLiveEl();
  };

  detachCanvasClick = () => {
    // Detach from the node we actually bound to -- getElementById can already
    // resolve to a NEWER canvas element by the time we unmount.
    if (this._boundCanvasEl) {
      this._boundCanvasEl.removeEventListener('click', this._handleCanvasClick);
      this._boundCanvasEl = null;
    }
    window.removeEventListener('dockCanvasReady', this._onDockCanvasReady);
    window.removeEventListener('resize', this._recheckCanvasClick);
    window.removeEventListener('orientationchange', this._recheckCanvasClick);
    if (this._recheckCanvasClick.cancel) {
      this._recheckCanvasClick.cancel();
    }
    this._canvasClickBound = false;
  };

  componentWillUnmount() {
    this.detachCanvasClick();
    $(document).off(ActionTypes.USER_IS_LOGGED_IN, this.userHasLoggedIn);
    $(document).off('click', this.handleWrapperBlur);
    $(document).off(ActionTypes.OPEN_MOBILE_NAVIGATION);
    $(document).off(ActionTypes.CHANGE_MOBILE_MENU_CONTENT_TYPE);
    if (Config.isVisualizerManagement()) {
      window.removeEventListener("message", this.messageListening);
    }
    if (this.props.toggleDesktopNavigation) {
      this.props.toggleDesktopNavigation(false)
    }
    if (this.props.setActiveNavigationNames) {
      this.props.setActiveNavigationNames("", "")
    }
  }

  _UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.visualizerTutorialStep === 2 && (this.props.visualizerTutorialStep === 1)
      && this.props.setVisualizerTutorialStep
      && this.props.showVisualizerTutorial) {
      this.openLayoutMenu(() => {
        const $scrollList = $(".layout-list");
        if (!$scrollList || !$scrollList.find(".active") || !$scrollList.find(".active").offset()) {
          return false
        }
        $scrollList.animate({scrollLeft: $scrollList.find(".active").offset().left}, 800, () => {
          // $("html, body").animate({scrollTop: document.body.scrollHeight/4}, 500);
          setTimeout(() => {
            setTimeout(() => {
              this.closeNavigation();
              this.props.setVisualizerTutorialStep(3);
              this.props.showVisualizerTutorial(true);
            }, 300)
          }, 600)
        });
      });
    }
    const layout = getCurrentLayout();
    if(!this.state.designNavigationItems || !this.state.designNavigationItems.length) {
      this.setState({designNavigationItems: layout.designNavigationItems()});
    }
  }

  updateComponent = () => {
    this.forceUpdate();
  };

  userHasLoggedIn = () => { // click on current active item after unlock
    const layout = getCurrentLayout();
    if (this.props.activeFeature && this.state.showNavigation && this.state.contentType === ContentType.Design) {
      if (this.state.childNavigationItem) {
        const navItemToClick = layout.designNavigationItems(this.state.childNavigationItem, {}, "", true)
          .find(navItem => {
            return this.props.activeFeature.dbFeature.id === navItem.part.dbFeature.id;
          });
        if (navItemToClick) {
          this.handleNavigationItemClick(navItemToClick);
        }
      } else {
        this.handleNavigationItemClick({
          part: this.props.activeFeature
        });
      }
      this.props.refreshCB();
    } else if (this.state.contentType === ContentType.DisplayRoom && (this.defaultPresetIndexToClick || this.defaultPresetIndexToClick === 0)
      && (!this.props.fabricatorSettings.twoFA || (this.props.fabricatorSettings.twoFA && this.props.isPhoneNumberValidated))) {
      this.handleDefaultPresetClick(this.defaultPresetIndexToClick)
    }
    this.forceUpdate(); // update react virtualized grid for Safari mobile
  };

  setIframeMessaging = () => {
    if (Config.isVisualizerManagement()) {
      window.addEventListener("message", this.messageListening);
    }
  };

  messageListening = (event) => {
    if (event.data && event.data.action === VISUALIZER_MANAGEMENT_ACTIONS.closeVisualizerNavigation) {
      this.closeMobileNavigationMenu();
    }
  };

  closeMobileNavigationMenu = () => {};

  triggerOpenNavigationMenu = (hoveredZone, clickedParent, activeNavigationFilter = null) => {
    const layout = getCurrentLayout();
    const designNavigationItems = layout.designNavigationItems();
    const menuItemToShow = clickedParent
      ? designNavigationItems.find(item => item.text === clickedParent)
      : designNavigationItems.find(item => item.text === hoveredZone);

    if (menuItemToShow) {
      this.setState({
        parentNavigationItem: menuItemToShow,
        childNavigationItem: null
      }, () => {

        if (menuItemToShow.part.menuType === PartMenuType.Simple) {
          this.checkIfAllFeaturesReceived(menuItemToShow, "parentNavigationItem");
        }

        if (menuItemToShow.part.handleClick) {
          menuItemToShow.part.handleClick();
        }
        // this.props.refreshCB();  // this refresh canvas (making redraw), but we need green zone to be shown! if needed - make settimeout 2 secs

        if (clickedParent) {
          const subMenuItemToShow = this.state.parentNavigationItem.part.subParts().find(item => {
            return item.text === hoveredZone
          });
          if (subMenuItemToShow) {
            this.handleSubPartClick(subMenuItemToShow, activeNavigationFilter);
          }
        }

      });
      this.props.setDefaultSelectionGroup(menuItemToShow.part.partName);
    }
    if (hoveredZone === "Floor") {
      $('html, body').animate({scrollTop: document.body.scrollHeight}, 800);
    } else if (hoveredZone === "Ceiling" || hoveredZone === "Window") {
      $('html, body').animate({scrollTop: 0}, 800);
    }
  };

  handleParentItemClick = (item) => {
    this.setState({
      parentNavigationItem: item,
      showFilterSelection: item.text === "Floor" && item.part.allFeaturesReceived, // show filters only if subItemPart has all features
    }, () => {
      // if (subParts[0] && (subParts[0].part.menuType !== PartMenuType.Simple)) {
      //   this.handleSubPartClick(subParts[0])
      // }
      if (item.text === "Walls" || item.text === "Shower" || item.text === "Bathtub" || item.text === "Vanity" || item.text === "Toilet"
        || (item.menuType === PartMenuType.Complex)) {
        const subParts = getSideBarSubParts(this.state.parentNavigationItem.part);
        if (subParts.length) {
          this.handleSubPartClick(subParts[0])
        }
      }
      if ((item.text === "Ceiling" &&
        (document.kvConfig.visualizerType === "Bathroom" || document.kvConfig.visualizerType === "BV")) || item.text === "Window") {
        this.setState({
          childNavigationItem: null
        });
        this.checkIfAllFeaturesReceived(item, "parentNavigationItem");
      }
      this.scrollToDefault(item);
    });
    this.props.setDefaultSelectionGroup(item.part.partName);
  };

  handleLayoutItemClick = layoutType => {
    const layout = getCurrentLayout();
    if (document.kvConfig.visualizerType === "Kitchen" && layout.getCurrentLayoutAbbreviation().includes("I")
      && !LayoutAbbreviations[layoutType].includes("I")) {
      this.resetNavigation();
    }
    if (layout.type !== layoutType) {
      this.changeLayout(layoutType)
    }
  };

  resetNavigation = () => {
    this.setState({
      parentNavigationItem: null,
      childNavigationItem: null,
      searchText: ""
    });
    this.props.setActiveFeature(null);
    if (this.props.setActiveNavigationFilter) {
      this.props.setActiveNavigationFilter(CABINET_WIZARD_BUTTONS[0].buttonId);
      this.props.setActiveNavigationFilterStepIndex(0);
    }
  };

  getSearchProducts = (searchText) => {
    if (searchText && searchText.length > 2) {
      this.props.setNavigationLoading(true);
      const childItem = this.state.childNavigationItem ? this.state.childNavigationItem.part : this.state.parentNavigationItem.part;
      const promises = [searchProductRequest(childItem, searchText)];
      if (COUNTERTOP_GROUP.includes(childItem.partId) && document.kvConfig.visualizerType !== "kvScene") {
        // we have requests on click
        const layout = getCurrentLayout();
        COUNTERTOP_GROUP.forEach(neededPartId => {
          if (neededPartId !== childItem.partId) {
            const featureGroup = layout.getFeatureGroupByPartId(neededPartId);
            if (featureGroup) {
              promises.push(Navigation.searchFeaturesByName(featureGroup, searchText, 1000));
            }
          }
        });
      }
      Promise.all(promises)
        .then(() => {
          this.props.setNavigationLoading(false); // for loading & desktop update
          this.setState({  // for mobile update
            render: false,
          }, () => {
            this.setState({
              render: true,
            });
          });
        })
    }
  };

  searchAPIDebounced = debounce(this.getSearchProducts, 500);

  handleSearchInputChange = async (event) => {
    const searchText = event.target.value;
    this.setState({
      searchText
    });
    await this.searchAPIDebounced(searchText);
  };

  ponyWallAndLeftWallClick = (menuItem) => {
    const layout = getCurrentLayout();
    if (!this.props.fabricatorSettings.leadCapture || (this.props.fabricatorSettings.leadCapture && this.props.userIsLoggedIn)) {
      if (menuItem.part.partId === "shower_body" && (menuItem.text === "Left Shower Wall" || menuItem.text === "Pony Wall")) {
        const shower = layout.parts.Shower;
        const activeShower = shower.getActiveShowerGroup();
        const dimensions = getMetadataByDimensions(activeShower.showerDimensions());
        const wallParent = layout.parts.Walls;
        if (menuItem.text === "Left Shower Wall" && dimensions === "Pony" && wallParent.ponyWall.placeholderChanged) {  // switch from Pony -> to Left Shower Wall
          const name1 = wallParent.ponyWall.activeFeature.getSplittedFeatureName();
          this.receiveAllFeaturesAndClickFeatureByName(wallParent, "left_shower_wall", name1);
        } else if (menuItem.text === "Pony Wall" && dimensions !== "Pony" && wallParent.wallExL.placeholderChanged) {
          const name1 = wallParent.wallExL.activeFeature.getSplittedFeatureName();
          this.receiveAllFeaturesAndClickFeatureByName(wallParent, "pony_wall", name1);
        }
      }
    }
  };

  receiveAllFeaturesAndClickFeatureByName = (parent, partId, name1) => {
    const exLSubPart = parent.getRelatedItems().find(relItem => relItem.partId === partId);
    const findAndClick = () => {
      const wallExLFeature = parent.wallExL.navigationSubItems().find(navItem => {
        return navItem.part.getSplittedFeatureName() === name1
      });
      if (wallExLFeature) {
        wallExLFeature.part.handleClick(true);
        this.props.refreshCB();
      }
    };
    findAndClick(); // first try without the request
    this.checkIfAllFeaturesReceived({part: exLSubPart}, null, findAndClick); // then receive all walls
  };

  _menuOpened = () => {
    if (isIframe() && window.parent) {
      window.parent.postMessage({
        action: 'menu_opened',
        payload: {}
      }, "*");
    }
    if (this.props.setDemoPointClicked && !this.props.visualizerTutorialIsOpened) {
      this.props.setDemoPointClicked()
    }
    if (this.props.toggleDesktopNavigation) {
      this.props.toggleDesktopNavigation(true)
    }
    if (this.props.setModuleContextMenuType) {
      this.props.setModuleContextMenuType(MODULE_CONTEXT_MENU_TYPES.Filters)
    }
  };

  renderErrorPopup(message) {
    this.props.changeMessageBoxState({
      visible: true,
      error: true,
      message,
      buttons: [{
        text: "messageBox.buttonOk",
        color: 'red',
        click: () => {
          this.props.changeMessageBoxState({visible:false});
        }
      }]
    });
  }

  itemClick = async (item, ignoreLocked) => {

    const layout = getCurrentLayout();

    if (item && item.text === "Floor") {
      $('html, body').animate({scrollTop: document.body.scrollHeight}, 800);
    } else if (item && item.text === "Ceiling") {
      $('html, body').animate({scrollTop: 0}, 800);
    }

    if (layout.visualizerType === "bvScene") {
      await searchForSameNameWallsBeforeFeatureApply(item.part);
    }

    if (layout.isNewLayout && !item.part.relatedItems) {

      const applyFeature = async (feature) => {

        if (featureCanChangeShowerSize(feature)) {
          await searchForSameNameWallsBeforeFeatureApply(feature);
        }

        navFeatureCLick(feature, true, ignoreLocked);

        const applyToLogic = getApplyToLogic(item.part);
        if (applyToLogic && Array.isArray(applyToLogic.currentApplyToArray) && applyToLogic.currentApplyToArray.length) {
          await clickOnSimilarFeatures(item.part, applyToLogic, true);
        }
      }

      // const compatabilityLogic = checkForCompatabilityAlert(item.part);
      // if (compatabilityLogic.length) {
      //   store.dispatch(setLookCompatabilityAlert({
      //     visible: true,
      //     compatabilityLogic,
      //     clickedFeature: item.part,
      //     applyFunction: applyFeature.bind(this, item.part) // always apply features from this popup
      //   }));
      //   return false
      // }

      await applyFeature(item.part);

    } else {

      await item.part.handleClick(ignoreLocked);

      if (this.isWallItem(item.part) && item.part.getParent().getParent().allWallsApplied) {
        this.applyAllWalls(item.part, ignoreLocked);
      }
      if (CABINET_GROUP.includes(item.part.partId) || CABINET_GROUP_BATHROOM.includes(item.part.partId)) {
        const featureIsLocked = getFeatureIsLocked(item.part);
        CabinetSwitchers.applyAllCabinets(item.part, !featureIsLocked || ignoreLocked);
      } else if (COUNTERTOP_GROUP.includes(item.part.partId) || COUNTERTOP_GROUP_BATHROOM.includes(item.part.partId)) {
        const featureIsLocked = getFeatureIsLocked(item.part);
        CountertopSwitchers.applyAllCountertops(item.part, !featureIsLocked || ignoreLocked);
      }
    }

    if (item.part.getParent && item.part.getParent().disabled) {
      const itemParent = item.part.getParent();
      const itemIsLocked = getFeatureIsLocked(item.part, ignoreLocked);
      let exLAndBathtubAndSmallRoom = false;
      if (itemParent.partId === "left_shower_wall" && layout.type === 0) {
        const showerBody = layout.parts.Shower.showerBody;
        if (showerBody && showerBody.disabled) {
          exLAndBathtubAndSmallRoom = true
        }
      }
      if (itemParent.disabled && !exLAndBathtubAndSmallRoom && !itemIsLocked) {
        itemParent.disabled = false;
        itemParent.disabledClick(); // disable also related parts
        store.dispatch(toggleUpdateDisableFeatureGroupRadio(true));
        store.dispatch(toggleUpdateDisableFeatureGroupRadio(false));
      }
    }
    if (item.part.getParent && item.part.getParent().getParent) { // enable shower if child is clicked
      const parent = item.part.getParent().getParent();
      if (parent.partName === "Shower" && parent.showerBody.disabled) {
        parent.showerBody.disabled = false;
        parent.showerBody.disabledClick(); // enable also related parts
      }
    }
    $(window).trigger(ActionTypes.CHANGE_LAYOUT); // update canvas
    store.dispatch(updateCanvasCount()); // for look remove button
  };

  callMetaMathesFailedPopup = (item, nonCompatibleWith) => {
    // console.log('item.matchesMetaFailedArray', item.matchesMetaFailedArray);
    const featureIsLocked = getFeatureIsLocked(item.part);
    if (!featureIsLocked) {
      const message = {
        id: "messageBox.metaDataMatchesFailed",
        featureGroup: item.part.getParent().partName.toLowerCase(),
        featureName: item.part.getFeatureName(),
        nonCompatibleWith
      };
      this.props.changeMessageBoxState({
        visible: true,
        message,
        buttons: [{
          text: "messageBox.buttonYes",
          color: 'green',
          click: () => {
            item.part.handleChangeParent(nonCompatibleWith); // change parent(vanity size)
            item.part.handleClick(); // set active
            const childNavigationItem = this.state.childNavigationItem;
            this.setState({ // update component & navigation
              childNavigationItem: null,
            },() => {
              this.setState({
                childNavigationItem
              })
            });
            setTimeout(() => {
              scrollToDivInArea($('.feature.active'), $('.categories-list'));
            }, 1000);
            this.props.changeMessageBoxState({visible:false});
          }
        },{
          text: "messageBox.buttonNo",
          color: "blue",
          click: () => {
            this.props.changeMessageBoxState({visible:false});
          }
        }]
      });
    }
  };

  callToiletFailPopup = (clickFrom, item, ignoreLocked = false) => {
    const featureIsLocked = getFeatureIsLocked(item.part, ignoreLocked);
    if (!featureIsLocked) {
      const message = (clickFrom === 'toilet') ? "messageBox.toiletMetaDataFailed" : "messageBox.toiletMetaDataFailedVanity";
      const buttons = (clickFrom === 'toilet')
        ? [{
          text: "messageBox.buttonOk",
          color: "blue",
          click: () => {
            this.props.changeMessageBoxState({visible:false});
          }
        }]
        : [{
          text: "messageBox.buttonNo",
          color: "blue",
          click: () => {
            this.props.changeMessageBoxState({visible:false});
          }
        },{
          text: "messageBox.buttonYes",
          color: "green",
          click: () => {
            this.itemClick(item, ignoreLocked);
            this.props.changeMessageBoxState({visible:false});
          }
        }];
      this.props.changeMessageBoxState({
        visible: true,
        message,
        buttons
      });
    }
  };

  toggleApplyWallsCheckbox = () => {
    const wallParent = this.state.parentNavigationItem.part;
    wallParent.allWallsApplied = !wallParent.allWallsApplied;
    if (!wallParent.allWallsApplied && this.shouldRecoverWalls) {
      wallParent.recoverPrevioslySelected(this.state.childNavigationItem.part)
    } else if (
      wallParent.allWallsApplied
      && this.state.childNavigationItem
      && this.state.childNavigationItem.part
      && this.state.childNavigationItem.part.activeFeature
      && this.state.childNavigationItem.part.placeholderChanged) {
      this.applyAllWalls(this.state.childNavigationItem.part.activeFeature, false);
    }
    this.props.refreshCB();
  };

  rememberWallsSelection = () => {  // this is set when new Wall Navigation Item is clicked
    const featureGroup = this.state.childNavigationItem.part;
    if ((this.isWallItem(featureGroup) || featureGroup.allWallsCanBeApplied)
      && this.state.parentNavigationItem.part.setPrevioslySelected) {
      this.state.parentNavigationItem.part.setPrevioslySelected(featureGroup);
    }
    this.shouldRecoverWalls = false;
  };

  applyAllWalls = (navigationItemPart, ignoreLocked) => {
    // console.log('navigationItem', navigationItem);
    const layout = getCurrentLayout();
    const wallParent = this.state.parentNavigationItem.part;
    const allWalls = wallParent.relatedItems;

    if (document.kvConfig.visualizerType === "Bathroom" || document.kvConfig.visualizerType === "BV") {
      allWalls.forEach((relatedItem) => {
        if (this.isWallItem(relatedItem) && (relatedItem.partId !== navigationItemPart.partId)) {
          const wallsPartIds = ["right_shower_wall", "left_shower_wall", "pony_wall"];
          let featuresAvailableToClick = wallsPartIds.includes(relatedItem.partId)
            ? relatedItem.getAvailableFeatures()
            : relatedItem.features; // for other walls we don't have filters
          const navigationItemName = navigationItemPart.dbFeature.sharedFeatureName;
          const neededFeature = featuresAvailableToClick.find((feature) => {
            const featureName = feature.dbFeature.sharedFeatureName;
            return navigationItemName === featureName
          });
          // console.log('neededFeature', neededFeature);
          neededFeature && neededFeature.clickFromAllWalls(ignoreLocked);
        } else if (relatedItem.partId === "accent_wall" && !relatedItem.placeholderChanged) {
          relatedItem.disabled = true;
        }
      });
      const vanity = layout.parts["Vanity"];
      if (vanity.vanityBacksplash && !vanity.vanityBacksplash.placeholderChanged) {
        vanity.vanityBacksplash.disabled = true;
      }
    } else if (document.kvConfig.visualizerType !== "Bathroom") {
      allWalls.forEach((relatedItem) => {
        if (this.isWallItem(relatedItem) && (relatedItem.partId !== navigationItemPart.partId)) {
          const navigationItemName = navigationItemPart.dbFeature.sharedFeatureName;
          const neededFeature = relatedItem.features.find((feature) => {
            const featureName = feature.dbFeature.sharedFeatureName;
            return featureName === navigationItemName
          });
          // console.log('neededFeature', neededFeature);
          neededFeature && neededFeature.clickFromAllWalls(ignoreLocked);
        }
      });
    }

    this.shouldRecoverWalls = true;
    this.props.refreshCB();
  };

  handleSubTypeClick = subType => { // sidebar radio button click
    Analytics.sendClickEvent('sub-type-clicked-' + subType);
    if (this.props.changeActivePartRelatedItemIndex) {
      this.props.changeActivePartRelatedItemIndex(0); // set first item on materials page
    }
    this.state.parentNavigationItem.part.handleSubTypeClick(subType, this.handleNavigationItemClick);
    const childNavigationItem = this.state.parentNavigationItem.part.setDefaultPartAfterSubTypeClick();
    this.setState({
      childNavigationItem,
      showFilterSelection: childNavigationItem.part.allFeaturesReceived, // show filters only if subItemPart has all features
      showerWallWizardGroupsSelected: false,
      searchText: ""
    },() => {
      this.setNewActiveFeature();
      this.rememberWallsSelection();
      this.checkIfAllFeaturesReceived(childNavigationItem, "childNavigationItem");
    });
    /*set new materials page subIndex*/
    this.setActivePartRelatedItemIndex(childNavigationItem);
    this.props.refreshCB();
  };

  setActivePartRelatedItemIndex = (childNavigationItem) => {
    const layout = getCurrentLayout();
    let nextSubPartIndex = 0;
    if (this.state.parentNavigationItem && !layout.qtCategories) { // we don't need to set for qtCategories
      const subParts = childNavigationItem.part.getParent().subParts(false);
      nextSubPartIndex = subParts.findIndex(currentSubPart => {
        return currentSubPart.part.partId === childNavigationItem.part.partId;
      });
    }
    setTimeout(() => {
      this.props.changeActivePartRelatedItemIndex(nextSubPartIndex); // setTimeout is needed cause it needs parent to be updated
    }, 0);
  };

  setNewActiveFeature = (subNavigationItem) => {
    if (!subNavigationItem) {
      subNavigationItem = this.state.childNavigationItem || this.state.parentNavigationItem || null;
    }

    if (subNavigationItem) {
      const featureToSet = ((this.props.fabricatorSettings.leadCapture && !(document.kvConfig.isBackend && document.kvConfig.jobId && document.kvConfig.canSaveQuote))
        && !this.props.userIsLoggedIn && subNavigationItem.part.activeLockedFeature)
      || ((this.props.fabricatorSettings.leadCapture && !(document.kvConfig.isBackend && document.kvConfig.jobId && document.kvConfig.canSaveQuote))
        && this.props.userIsLoggedIn
        && subNavigationItem.part.activeLockedFeature
        && !subNavigationItem.part.placeholderChanged)
        ? subNavigationItem.part.activeLockedFeature
        : subNavigationItem.part.activeFeature;
      this.props.setActiveFeature(featureToSet);
    }
  };

  handleDefaultPresetClick = (index, presetIsLocked) => {
    const layout = getCurrentLayout();
    Analytics.sendClickEvent('preset-selected-' + index);
    if (presetIsLocked) {
      this.defaultPresetIndexToClick = index;
      this.props.toggleUserPopup({
        userPopupOpened: true
      });
      return
    }
    this.defaultPresetIndexToClick = null;
    this.setState({
      activeDefaultPreset: index
    }, () => {
      window.requestInProcess = true;
      loaderEnable();
      const defaultPreset = this.props.bvPresets[index];
      console.log('defaultPreset', defaultPreset);
      const cabinetParent = layout.parts["Cabinet"];
      const noCabinets = (cabinetParent && cabinetParent.topCabinet
        && !cabinetParent.topCabinet.allFeaturesReceived) || (cabinetParent && cabinetParent.bottomCabinet
        && !cabinetParent.bottomCabinet.allFeaturesReceived);
      if (noCabinets && (document.kvConfig.visualizerType !== "kvScene")) {
        const neededParts = ["top_cabinet", "bottom_cabinet"];
        const allRelated = cabinetParent.relatedItems.filter((relatedItem) => {
          return neededParts.includes(relatedItem.partId) && !relatedItem.allFeaturesReceived
        });
        const promises = allRelated.map((relatedItem) => {
          return getBvGroupFeatures(relatedItem.dbName || relatedItem.partName).then(response => {
            relatedItem.setGroupFeatures(Array.isArray(response) ? response : []);
            return response
          })
        });
        Promise.all(promises)
          .then(() => this.finishPresetLoading(layout, defaultPreset))
      } else {
        loaderEnable();
        this.finishPresetLoading(layout, defaultPreset);
      }
    });
  };

  finishPresetLoading = (layout, preset) => {
    layout.setItemsFromBvState(preset)
      .then(() => {
        window.requestInProcess = false;
        loaderDisable();
      });
  }

  handleUserLoginClick = (userPopupType = UserPopupTypes.Unlock) => {
    this.props.toggleUserPopup({
      userPopupOpened: true,
      userPopupType
    });
  };

  currentActiveItemIsLocked = (useWizard) => {

    const {visualizerManagement, isBackend, jobId, canSaveQuote} = document.kvConfig;
    const {fabricatorSettings, isPhoneNumberValidated, activeFeature, filterGroups, activeQuoteIndex} = this.props;
    const {showFeatureWizard, wizardActiveItemIsLocked} = this.state;

    if (!fabricatorSettings.leadCapture
      || (fabricatorSettings.leadCapture && visualizerManagement)
      || (fabricatorSettings.leadCapture && isPhoneNumberValidated)
      || (fabricatorSettings.leadCapture && (isBackend && jobId && canSaveQuote))){
      return false
    }

    const itemHasLockedFilters = () => {
      let lockedFilters = false;
      const filterValues = activeFeature && activeFeature.dbFeature && activeFeature.dbFeature.filterValueIDs;
      if (filterValues) {
        lockedFilters = Object.keys(filterValues).some((filterKey) => {
          const filterGroup = filterGroups.find(group => group.id === +filterKey);
          const filterValue = filterGroup && filterGroup.values && filterGroup.values.find(value => value.id === filterValues[filterKey][0]);
          return filterValue && filterValue.lockedInWizard
        });
      }
      return lockedFilters
    };

    return (
      activeFeature
      && activeFeature.getParent().firstClick[activeQuoteIndex]
      && activeFeature.dbFeature
      && !activeFeature.dbFeature.unlocked
      && !isFeatureNotInVisualizerNow(activeFeature)
      && !(useWizard && showFeatureWizard)
    ) || (useWizard && showFeatureWizard && wizardActiveItemIsLocked) || itemHasLockedFilters()
  };

  checkedForLockedPresets = () => {
    // const layout_typelayout_type: 1
    const layout = getCurrentLayout();
    const fabricatorSettings = this.props.fabricatorSettings;
    const showSmallRoomLayout = fabricatorSettings &&
      (fabricatorSettings.showSmallDesignForClients
        || (fabricatorSettings.showSmallDesignFromDashboard && document.kvConfig.isBackend));
    return Array.isArray(this.props.bvPresets) && this.props.bvPresets.length
      ? this.props.bvPresets
        .filter(preset => {
          if (!showSmallRoomLayout && (document.kvConfig.visualizerType === "Bathroom"
            || document.kvConfig.visualizerType === "BV")) {
            return preset.layout_type !== 0
          }
          return preset
        })
        .map((preset) => {
          if (preset.presetUnlocked) {
            preset.presetIsLocked = false
          } else {
            preset.presetIsLocked = this.props.fabricatorSettings.leadCapture
              && !(document.kvConfig.isBackend && document.kvConfig.jobId && document.kvConfig.canSaveQuote)
              && !this.props.isPhoneNumberValidated && (!preset.presetUnlocked || layout.bvStateHasLockedItems(preset))
          }
          // console.log("preset.presetIsLocked", preset.presetIsLocked);
          return preset
        }).sort((a, b) => a.presetIsLocked !== b.presetIsLocked ? a.presetIsLocked < b.presetIsLocked ? -1 : 1 : 0) // sort by presetIsLocked
      : []
  };

  closeContextMenu = () => {
    this.setState({
      contextMenuOpen: false,
    })
  };

  /*** WIZARD ***/

  exitFeatureWizard = (wizardGroups, partId) => {
    this.setState({
      wizardStepIndex: 0,
      showFeatureWizard: false,
      wizardActiveItemIsLocked: false,
      searchText: ""
    });
    this.setWizardGroups(wizardGroups, partId);
  };

  enableFeatureWizard = (wizardStepIndex) => {
    this.setState({
      wizardStepIndex,
      showerWallWizardGroupsSelected: wizardStepIndex !== 0
    }, () => {
      this.setState({
        showFeatureWizard: true,
      })
    });
  };

  setWizardStepIndex = (wizardStepIndex) => {
    this.setState({
      wizardStepIndex
    })
  };

  setWizardGroups = (wizardGroups, partId) => {
    if (!Array.isArray(wizardGroups)) {
      return;
    }
    let wizardGroupsName = this.getWizardGroupsByPartId(partId);
    if (typeof partId !== "string") {
      // some callers (FeatureWizardSteps, BodyPanelWizardSteps) don't pass a partId -> use the active sub part
      const activeSubPart = this.state.childNavigationItem && this.state.childNavigationItem.part;
      wizardGroupsName = activeSubPart ? this.getWizardGroupsByPartId(activeSubPart.partId) : "";
    }
    if (!wizardGroupsName || !Array.isArray(this.state[wizardGroupsName])) {
      return; // part has no wizard groups (e.g. bvLook shower_wall)
    }
    this.setState({
      [wizardGroupsName]: this.state[wizardGroupsName].map((wizardGroup) => {
        const currentGroup = wizardGroups.find(wGroup => wGroup.filterName === wizardGroup.filterName);
        if (currentGroup) {
          wizardGroup.selectedValueId = currentGroup.selectedValueId;
          wizardGroup.selectedValueName = currentGroup.selectedValueName;
          wizardGroup.hidden = currentGroup.hidden;
          wizardGroup.values = currentGroup.values;
        }
        return wizardGroup
      })
    })
  };

  setWizardLockedItem = (itemIsLocked) => {
    this.setState({
      wizardActiveItemIsLocked: itemIsLocked
    })
  };

  resetActiveFeature = () => {
    this.props.setActiveFeature(null);
    this.setState({
      wizardActiveItemIsLocked: false
    })
  };

  resetWizardSteps = () => {
    this.setState({
      vanityWizardGroups: vanityWizardFilters.map((filterName) => { // filterGroupsId's & their selected values
        return {
          filterName,
          selectedValueId: null,
          selectedValueName: "",
          hidden: filterName === "Material"
        }
      }),
      showerWallWizardGroups: showerWizardFilters.map((filterName) => {
        const wizardFilters = ["SlabColor", "TileColor", "TilePattern", "AcrylicPattern", "AcrylicColor"];
        return {
          filterName,
          selectedValueId: null,
          selectedValueName: "",
          hidden: wizardFilters.includes(filterName)
        }
      }),
      showFeatureWizard: true,
      wizardStepIndex: 0,
      wizardActiveItemIsLocked: false,
    })
  };

  /**
   * Wizard groups array for a partId, or null when the part has no wizard groups.
   * canUseWizard alone is not enough: e.g. bvLook's shower_wall / shower_wall_accent set it but have no groups.
   */
  getWizardGroupsForPartId = (partId) => {
    const wizardGroupsName = this.getWizardGroupsByPartId(partId);
    const wizardGroups = wizardGroupsName ? this.state[wizardGroupsName] : null;
    return Array.isArray(wizardGroups) ? wizardGroups : null;
  };

  getWizardGroupsByPartId = (partId) => {
    switch (partId) {
      case "vanity_cabinet":
        return "vanityWizardGroups";
      case "shower_interior_wall":
        return "showerWallWizardGroups";
      default:
        return "";
    }
  };

  getFilterDisplayName = (filterName, intl = null) => {
    switch (filterName) {
      case "DoorStyle":
        return intl ? intl.formatMessage({id: "Door Style"}) : "Door Style"
      case "Material":
        return intl
          ? intl.formatMessage({id: this.state.childNavigationItem.part.partId === "vanity_cabinet" ? "WoodType" : "Material"})
          : this.state.childNavigationItem.part.partId === "vanity_cabinet" ? "Wood Type" : "Material";
      case "AcrylicColor":
      case "DuraBathColor":
      case "SlabColor":
      case "TileColor":
        return intl ? intl.formatMessage({id: "Color"}) : "Color";
      case "AcrylicPattern":
        return intl ? intl.formatMessage({id: "Pattern"}) : "Pattern";
      default:
        return intl ? intl.formatMessage({id: filterName}) : filterName
    }
  };

  removeFilterSelection = () => {
    this.setState({
      showFilterSelection: false
    })
  };

  toggleWizardFilterSelection = (showerWallWizardGroupsSelected) => {
    this.setState({
      showerWallWizardGroupsSelected
    })
  };

  setWizardFiltersFromActiveItem = (activeFeature) => {

    const {fabricatorSettings} = this.props;
    const useWizard = fabricatorSettings && (fabricatorSettings.wizardConsumers || (fabricatorSettings.wizardClients && document.kvConfig.isBackend));

    const partId = this.state.childNavigationItem && this.state.childNavigationItem.part
      && this.state.childNavigationItem.part.partId;
    if (useWizard && this.getWizardGroupsForPartId(partId)) {
      const currentActiveFilters = activeFeature.dbFeature.filterValueIDs;
      const wizardGroupsName = this.getWizardGroupsByPartId(partId);

      let wizardGroups = this.state[wizardGroupsName].map((wizardGroup) => {
        if (partId === "vanity_cabinet") {
          const filterGroup = this.props.filterGroups.find(filterGroup => {
            return filterGroup.name === wizardGroup.filterName
          });
          let filterGroupValue = {};
          if (filterGroup && currentActiveFilters[filterGroup.id]) {
            const selectedFilterValueId = currentActiveFilters[filterGroup.id][0];
            filterGroupValue = filterGroup && filterGroup.values.find(filterGroupValue => {
              return filterGroupValue.id === selectedFilterValueId
            });
          }
          // console.log('filterGroupValue', filterGroupValue);
          if (wizardGroup.filterName === "Material") { // check for existing BV filters
            const doorStyleFilter = this.props.filterGroups.find(filterGroup => filterGroup.name.trim() === "DoorStyle");
            if (doorStyleFilter) {
              const doorStyleActiveValue = currentActiveFilters[doorStyleFilter.id];
              const doorStyleFilterValue = doorStyleFilter.values.find(filterObj => {
                return doorStyleActiveValue && filterObj.id === doorStyleActiveValue[0]
              });
              // console.log('doorStyleFilterValue', doorStyleFilterValue);
              wizardGroup.hidden = filterGroupValue && doorStyleFilterValue && !NotQCVanityDoorStylesFilters.includes(doorStyleFilterValue.value);
            }
          }
        } else if (partId === "shower_interior_wall") {
          const stepName = wizardGroup.filterName.toLowerCase();
          const materialFilter = this.props.filterGroups.find(filterGroup => filterGroup.name.trim() === "Material");
          if (Object.keys(currentActiveFilters).length && materialFilter && currentActiveFilters[materialFilter.id]) { // check for existing BV filters
            const materialValueId = currentActiveFilters[materialFilter.id][0];
            const materialValue = materialFilter.values.find(val => val.id === materialValueId);
            // console.log('materialValue.value', materialValue.value);
            wizardGroup.hidden = (materialValue && (
              (materialValue.value !== "DuraBath" && stepName === "durabathcolor")
              || (materialValue.value !== "DuraBath" && materialValue.value !== "Tile" && stepName === "tilepattern")
              || (materialValue.value !== "Acrylic" && stepName === "acrylicpattern")
              || (materialValue.value !== "Acrylic" && stepName === "acryliccolor")
              || (materialValue.value !== "Tile" && stepName === "tilecolor")
              || (materialValue.value !== "Slab" && stepName === "slabcolor")
            ))
          }
        }
        return wizardGroup
      });

      this.setState({
        [wizardGroupsName]: wizardGroups
      });
    }
  };

  /*** WIZARD END ***/

  setNavigationFilterIfTheChildWasChanged(childNavigationItemPartId, activeNavigationFilter) {
    if (this.props.setActiveNavigationFilter && !activeNavigationFilter) {
      if (childNavigationItemPartId === "edge_profile"
        || childNavigationItemPartId === "center_island_edge"
        && this.props.activeNavigationFilter !== COUNTERTOP_WIZARD_BUTTONS[3].buttonId) {
        this.props.setActiveNavigationFilter(COUNTERTOP_WIZARD_BUTTONS[3].buttonId);
        this.props.setActiveNavigationFilterStepIndex(3);
      } else if (childNavigationItemPartId === "countertop"
        || childNavigationItemPartId === "center_island_countertop"
        && (
          this.props.activeNavigationFilter !== COUNTERTOP_WIZARD_BUTTONS[0].buttonId
          || this.props.activeNavigationFilter !== COUNTERTOP_WIZARD_BUTTONS[1].buttonId
          || this.props.activeNavigationFilter !== COUNTERTOP_WIZARD_BUTTONS[2].buttonId
        )){
        this.props.setActiveNavigationFilter(COUNTERTOP_WIZARD_BUTTONS[0].buttonId);
        this.props.setActiveNavigationFilterStepIndex(0);
      } else if (childNavigationItemPartId === "backsplash"
        && !(this.props.activeNavigationFilter !== COUNTERTOP_WIZARD_BUTTONS[4].buttonId)) {
        this.props.setActiveNavigationFilter(COUNTERTOP_WIZARD_BUTTONS[4].buttonId);
        this.props.setActiveNavigationFilterStepIndex(4);
      }
    }
  }

  showPositionsPopup = (item, event) => {
    const itemParent = item.part.getParent ? item.part.getParent() : null;
    const featureIsLocked = getFeatureIsLocked(item.part);
    if (itemParent && !isNavItemNotInVisualizer(item) && !featureIsLocked
      && this.props.toggleNavItemPositionModal && itemParent.showLayerPositionsModal
      && itemParent.showLayerPositionsModal(item.part) && event) {
      const eventPosition = getEventPosition(event);
      this.props.toggleNavItemPositionModal({
        popupOpened: true,
        popupPosition: {
          left: eventPosition.x,
          top: eventPosition.y
        },
        activePartId: item.part.partId,
      });
      $(window).trigger(ActionTypes.UPDATE_ALL_ITEMS); // update buttons
      return true
    } else if (this.props.navItemPositionModal && this.props.navItemPositionModal.popupOpened) {
      this.props.toggleNavItemPositionModal({
        popupOpened: false,
      });
    }
    return false
  }

}
